import React, { useEffect, useState } from 'react'
import preloadimg from "../../assets/img/preloader1.gif";
import PBIVisuals from '../customVisuals/CustomVisuals';


const skeletonStyle = {
  backgroundColor: '#f0f0f0', // Set the background color for the skeleton
  position: 'relative',
  overflow: 'hidden',
  marginTop:"10px",
  width:"100%",
  boxShadow: "0px 0px 4px rgba(0,0,0,0.6)",
  border: "4px solid #eee",

};



const LandingKPIReport = (props) => {

  const [reportVisuals, setReportVisuals] = useState([])
  const [Loading,setLoading] = useState(true)
  const passtoken = JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"];

  const email = localStorage.getItem('myemail')
  const baseUrl = `${process.env.REACT_APP_SERVER_URL}/aipd/customVisuals/getVisualsV2`;

  useEffect(() => {
    const fetchViusals = async () => {
      await fetch(`${baseUrl}`, {
        headers: {
          "oidc-token": passtoken,
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.ok) {
            response.json().then((json) => {
              setReportVisuals(json);
              setLoading(false)
              //  console.log(isLoading);
            });
          }
        })
        .catch((err) => {
          setReportVisuals([]);
          setLoading(false)

        });
    };
    fetchViusals();
  }, [passtoken,baseUrl]);


  const defaultRL = props.defaultRL
  const rlTypeData = props.rlType



  return (
    <>
      {Loading && (
        <div style={{height:"420px"}} className="customVisuals_flex">
          <div style={skeletonStyle}>
            <div
              style={{
                position: "absolute",
                background: "white",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                zIndex: 1,
              }}
              className="pageLoading"
            >
              <img width={200} src={preloadimg} alt="Loading" />
            </div>
          </div>

          <div style={skeletonStyle}>
            <div
              style={{
                position: "absolute",
                background: "white",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                zIndex: 1,
              }}
              className="pageLoading"
            >
              <img width={200} src={preloadimg} alt="Loading" />
            </div>
          </div>

        </div>
      )}

      {!Loading && (
        <div className="visuals_container">
          {reportVisuals.length === 0 && (
            <div
              style={{
                boxShadow: "0px 0px 4px rgba(0,0,0,0.6)",
                height: "420px",
                padding: "1rem",
                borderRadius: "6px",
                border: "4px solid #eee",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                fontWeight: 500,
              }}
            >
              No Custom Visuals has been assigned to this Persona. Please ask the Administrator to add the Custom Visuals in this particular Persona
            </div>
          )}

          {reportVisuals.map((ivisuals, Index) => {
            return (
              <div
                key={Index}
                style={{
                  boxShadow: "0px 0px 4px rgba(0,0,0,0.6)",
                  height: "420px",
                  padding: "1rem",
                  borderRadius: "6px",
                  border: "4px solid #eee",
                  width: "99%",
                  paddingBottom: "5rem",
                }}
              >
                <PBIVisuals
                  report_id={ivisuals.report_id}
                  report_name={ivisuals.report_name}
                  visuals_id={ivisuals.visualName}
                  title={ivisuals.name}
                  defaultRL={defaultRL}
                  rlTypeData={rlTypeData}
                  filter1 = {ivisuals.filter1 === "null" ? "" :ivisuals.filter1}
                  filter2 = {ivisuals.filter2 === "null" ? "" :ivisuals.filter2}
                  filter3 = {ivisuals.filter3 === "null" ? "" :ivisuals.filter3}
                  filter4 = {ivisuals.filter4 === "null" ? "" :ivisuals.filter4}
                  filter5 = {ivisuals.filter5 === "null" ? "" :ivisuals.filter5}


                />
              </div>
            );
          })}
      
        </div>
      )}
    </>
  );
}

export default LandingKPIReport
